import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card, Checkbox, Alert } from 'antd';
import axios from 'axios';

const { Title, Text, Link } = Typography;

const CreateUserPage = () => {
  const [form] = Form.useForm();
  const [alert, setAlert] = useState({ type: '', message: '', visible: false });

  const handleSubmit = async (values) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/users`,
        {
          name: values.name,
          email: values.email,
          password: values.password,
        }
      );
      setAlert({
        type: 'success',
        message: 'Account created! Please check your email. You may now <Link to="/ui/login">log in.</Link>',
        visible: true,
      });
      form.resetFields();
    } catch (error) {
      setAlert({
        type: 'error',
        message: 'Account creation failed.',
        visible: true,
      });
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f6f6f6',
    }}>
      <Card style={{
        width: 650,
        padding: '40px 40px 32px 40px',
        boxShadow: '0 7px 24px 0 rgba(60,72,100,.16)',
      }}>
        <Title level={2}>Create Account</Title>
        <Text>
          Please enter your name, email and password to create a user account.
        </Text>

        {alert.visible && (
          <Alert
            style={{ marginTop: 16, marginBottom: 24 }}
            message={alert.message}
            type={alert.type}
            closable
            onClose={() => setAlert({ ...alert, visible: false })}
          />
        )}

        <Form
          form={form}
          name="register"
          style={{ marginTop: 0 }}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              { required: true, message: 'Please enter your name!' },
            ]}
          >
            <Input placeholder="First name and Surname" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Please enter a valid email!' },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: 'Please enter your password!' },
              { min: 10, message: 'Password must be at least 10 characters.' },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item
            name="agreement"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the agreement!')),
              },
            ]}
          >
            <Checkbox>
              I agree to the <Link href="#" target="_blank">Terms and conditions of use</Link>; and the <Link href="#" target="_blank">Privacy Policy</Link>.
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              SUBMIT
            </Button>
          </Form.Item>
                    <Form.Item>
            <Link href="/ui/login" style={{ float: 'left' }}>
              Return to login
            </Link>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateUserPage;
